import React, { Component } from "react";
import { connect } from "react-redux";
import SidebarList from "features/Admin/components/SidebarList";
import ElementFocus from "features/Admin/components/ElementFocus";
import {
	adminGetDocumentType,
	adminGetAllDocumentTypes,
	resetFocusDocumentType,
	initNewDocumentType,
	adminPatchDocumentType,
	adminPostDocumentType,
	adminDeleteDocumentType,
} from "services/documentType";
import AdminDataContainer from "features/Admin/components/AdminDataContainer";
import { Grid, Icon } from "semantic-ui-react";
import RedButton from "components/Buttons/RedButton";
import GeneralForm from "features/Admin/DocumentTypes/Forms/GeneralForm";
import { Form, Formik } from "formik";
import MainButton from "components/Buttons/MainButton";
import SecondaryButton from "components/Buttons/SecondaryButton";
import * as Yup from "yup";

const schemaValidation = Yup.object().shape({
	name: Yup.string().required("Champ requis"),
	title: Yup.string().required("Champ requis"),
	is_visible: Yup.boolean().required("Champ requis"),
	is_prescription_default: Yup.boolean().required("Champ requis"),
});

class DocumentTypesAdmin extends Component {
	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusDocumentType();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllDocumentTypes();
	};

	focusOnElement = (elt) => {
		this.props.adminGetDocumentType(elt);
	};

	onAddClick = () => {
		this.props.initNewDocumentType();
	};

	saveFocus = (values, setSubmitting) => {
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostDocumentType(values).then(() => {
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchDocumentType(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteDocumentType(this.props.documentTypes.focus.data);
	};

	render() {
		const { documentTypes } = this.props;
		const { focus, list } = documentTypes;
		const documentType = focus.data;
		const newDocumentType = documentType !== null && documentType.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={documentTypes.list}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity="TYPES DE DOCUMENT"
					addButtonText="Nouveau type"
					onAddButtonClick={this.onAddClick}
					defaultLabel={(e) => e.name}
					groupField="is_visible"
					groupFieldTrueName="Visible"
					groupFieldFalseName="Non visible"
					focusedEltId={documentType}
				/>

				<ElementFocus element={focus} list={list} entity="Types de document" icon="info">
					{documentType !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: documentType.id,
								name: documentType.name || "",
								title: documentType.title || "",
								is_visible: documentType.is_visible || true,
								is_prescription_default: documentType.is_prescription_default || false,
								order: documentType.order || 3,
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton type="button" style={{ float: "left" }} onClick={this.props.resetFocusDocumentType}>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name="save" />}
													type="submit"
													style={{ float: "left" }}
													isSubmitting={isSubmitting}
													disabled={Object.entries(errors).length > 0 && errors.constructor === Object}
												>
													{newDocumentType ? "Créer" : "Enregistrer"}
												</MainButton>

												{!newDocumentType && (
													<RedButton
														text={<Icon name="trash" />}
														type="button"
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: "right" }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer ribbonColor="red" ribbonLabel="Général">
													<GeneralForm />
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: "100%",
		width: "100%",
		paddingTop: 43,
		fontSize: 0,
		display: "flex",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
	},
};

const mapStateToProps = (state) => {
	return {
		documentTypes: state.admin.documentTypes,
	};
};

const mapDispatchToProps = {
	adminGetAllDocumentTypes,
	adminGetDocumentType,
	adminPatchDocumentType,
	adminDeleteDocumentType,
	resetFocusDocumentType,
	adminPostDocumentType,
	initNewDocumentType,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentTypesAdmin);
